import AOS from 'aos';
import 'aos/dist/aos.css';

document.addEventListener('DOMContentLoaded', _=> {
    if(document.querySelector('[data-aos]')) {
        AOS.init();
    }

    window.addEventListener('load', _ => {
        AOS.refresh();
    });
});

window.addEventListener('load', _ => {
    document.querySelectorAll('[data-aos]').forEach(el => {
        if(el.getBoundingClientRect().top < window.innerHeight) {
            el.setAttribute('data-aos', 'animated');
        }
    });
});
